/**
 * Extracts all Han script characters (i.e. all Kanji) from the input string.
 * This method uses Unicode property escapes (ES2018+), which should capture
 * all characters with the Han script, including all possible Kanji.
 *
 * @param text - The input string that may contain Kanji, numbers, letters, etc.
 * @returns A new string containing only characters that belong to the Han script.
 */
export function extractKanjis(text: string): string {
  const matches = text.match(/\p{Script=Han}/gu)
  return matches ? matches.join('') : ''
}

/**
 * Formats a duration in seconds to a human-readable format.
 * Shows seconds for durations < 60 seconds,
 * minutes and seconds for durations < 60 minutes,
 * hours, minutes, and seconds for durations >= 60 minutes.
 *
 * @param seconds - The duration in seconds
 * @returns A formatted duration string (e.g., "45s", "2m 30s", "1h 15m 30s")
 */
export function formatDuration(seconds: number): string {
  if (seconds < 60) {
    return `${Math.round(seconds)}s`
  }

  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = Math.round(seconds % 60)

  if (hours > 0) {
    const parts = [`${hours}h`]
    if (minutes > 0) {
      parts.push(`${minutes}m`)
    }
    if (remainingSeconds > 0) {
      parts.push(`${remainingSeconds}s`)
    }
    return parts.join(' ')
  }

  // Between 1 minute and 1 hour
  if (remainingSeconds > 0) {
    return `${minutes}m ${remainingSeconds}s`
  }

  return `${minutes}m`
}
